var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1221_475)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.0424,
    cy: 31.9577,
    r: 25.0424,
    fill: "#D00C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5704 42.2527C28.9072 42.2527 28.3393 42.0164 27.8666 41.5437C27.394 41.0711 27.1581 40.5036 27.1589 39.8412V24.1665H25.9531V21.7551H31.9818V20.5493H39.2163V21.7551H45.245V24.1665H44.0393V39.8412C44.0393 40.5044 43.803 41.0723 43.3303 41.5449C42.8577 42.0176 42.2902 42.2535 41.6278 42.2527H29.5704ZM41.6278 24.1665H29.5704V39.8412H41.6278V24.1665ZM31.9818 37.4297H34.3933V26.578H31.9818V37.4297ZM36.8048 37.4297H39.2163V26.578H36.8048V37.4297Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1221_475",
    x: 0,
    y: 0.915283,
    width: 70.085,
    height: 70.0847,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1221_475"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1221_475",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletebtn);
export default __webpack_public_path__ + "static/media/deletebtn.0adf3ae7dcbc677ebe309c75e99fc2b9.svg";
export { ForwardRef as ReactComponent };